export type IncomeDepositPayorFields = {
  payorDisplay?: string | null;
  payorNormalized?: string | null;
  payorRaw?: string | null;
};

/** Primary Payor column label — normalized employer name, not raw bank memo (Bug_139). */
export function incomeDepositPayorLabel(deposit: IncomeDepositPayorFields): string {
  return deposit.payorDisplay ?? deposit.payorNormalized ?? '—';
}

/** Verbatim bank description when it differs from the primary payor label. */
export function incomeDepositPayorRawCaption(deposit: IncomeDepositPayorFields): string | null {
  const raw = deposit.payorRaw?.trim();
  if (!raw) return null;
  const label = (deposit.payorDisplay ?? deposit.payorNormalized ?? '').trim();
  if (raw === label) return null;
  return raw;
}

export function incomeDepositPayorGroupKey(
  deposit: IncomeDepositPayorFields & { payorType?: string | null },
): string {
  return `${deposit.payorDisplay?.trim() || '—'}\u0000${deposit.payorType ?? '—'}`;
}
